export const getDropdownPositionStyles = (
  dropdown: HTMLDivElement,
  container: HTMLDivElement,
  offset: number
): string => {
  const dropdownRect = dropdown.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  const topPosition = containerRect.top - dropdownRect.height - offset;
  const bottomPositon = containerRect.top + containerRect.height + offset;

  const top =
    bottomPositon + dropdownRect.height > window.innerHeight ? topPosition : bottomPositon;

  const left =
    containerRect.left + dropdownRect.width > window.innerWidth
      ? containerRect.left + containerRect.width - dropdownRect.width
      : containerRect.left;

  return `translate(${left}px, ${top}px)`;
};
